<template>
    <div class="mb-4 flex flex-col gap-2">
        <div class="font-semibold flex items-center gap-2">
            <span class="inline-flex items-center justify-center w-5 h-5 rounded-full border border-primary text-primary text-xs shrink-0">{{ step }}</span>
            {{ $t('courseframe.personalizationStepLabel') }}
            <span class="text-base-content-subtle font-normal">({{ $t('courseframe.optional') }})</span>
        </div>
        <div class="text-xs text-base-content-subtle leading-5">
            {{ $t('courseframe.personalizationDescription') }}
        </div>
        <label for="courseframe-personalization-input" class="form-control w-full">
            <input
                id="courseframe-personalization-input"
                ref="personalizationInputEl"
                v-model="personalizedText"
                type="text"
                :placeholder="$t('courseframe.personalizationPlaceholder')"
                class="input input-bordered w-full text-sm"
                :maxlength="maxLength"
                data-cy="courseframe-personalization-input"
                @input="onInput"
            >
        </label>
        <div class="text-xs text-base-content-subtle">
            {{ $t('courseframe.charactersRemaining', { count: remainingCharacters, max: maxLength }) }}
        </div>

        <div class="text-xs bg-warning text-warning-content p-3 mt-2">
            <span class="font-semibold">{{ $t('courseframe.importantNoticeTitle') }}</span>
            {{ $t('courseframe.importantNoticeText') }}
            <MiscLink :to="$t('courseframe.cancellationLink')" class="link font-semibold">
                {{ $t('courseframe.cancellationLinkText') }}
            </MiscLink>
        </div>
    </div>
</template>

<script setup lang="ts">
import { COURSEFRAME_PERSONALIZATION_MAX_LENGTH } from '~/composables/useCourseframe'

defineProps<{
    /** Visible step number — shifts down on products without the golf-course search */
    step: number
}>()

const { personalizedText, hasEmoji } = useCourseframe()
const { t } = useI18n()

const maxLength = COURSEFRAME_PERSONALIZATION_MAX_LENGTH
const personalizationInputEl = ref<HTMLInputElement | null>(null)

const remainingCharacters = computed(() => Math.max(0, maxLength - personalizedText.value.length))

function onInput () {
    if (personalizationInputEl.value == null) return
    personalizationInputEl.value.setCustomValidity(hasEmoji(personalizedText.value) ? t('courseframe.personalizationEmojiError') : '')
}
</script>
